<template>
  <div>
    <headerSection :mainMenu="mainMenu"></headerSection>

    <!-- Running Text Section -->
    <RunningText
      text="เว็บตรง ไม่ล็อคยูส ฝาก-ถอน โอนไว 5 วินาที ไม่มีขั้นต่ำ ไม่ติดเทิร์น ไม่จำกัดการถอน คืนยอดเสีย 5% เเนะนำเพื่อนรับเพิ่ม 3% แอดมินบริการ 24 ชั่วโมง"
      extraClasses="home-style"
    />

    <!-- Main Layout Container -->
    <div class="main-layout">
      <!-- Desktop Layout -->
      <div class="desktop-layout desktop-only">
        <!-- Left Sidebar -->
        <LeftSidebar
          :leftMenuItems="leftMenuItems"
          :hoveredIndex="hoveredLeftIndex"
          :user="user"
          @menu-enter="onLeftMenuEnter"
          @menu-leave="onLeftMenuLeave"
        />

        <!-- Main Content Area -->
        <div class="main-content">
          <!-- Continue Cover Section -->
          <div class="x-cover x-index-event-container" style="padding-top: 0px;">
            <div class="container-fluid">
              <div class="row -contents-wrapper">
                <div class="col-12 col-md-6 -left-content">&nbsp;</div>
              </div>
            </div>
          </div>

          <!-- Main Menu Bar -->
          <MainMenuBar
            :mainMenuItems="mainMenuItems"
            :hoveredIndex="hoveredMainIndex"
            :user="user"
            @menu-enter="onMainMenuEnter"
            @menu-leave="onMainMenuLeave"
          />

          <!-- Continue Content -->
          <div class="content-wrapper">
            <div class="x-continue-container">
              <div class="container">
                <div class="row -continue-row-wrapper">
                  <div class="col-sm-12 col-lg-12 col-12 recommend_section">
                    <fieldset class="form-group text-center mb-0 px-1">
                      <div class="row mt-2 mb-0 mb-4 justify-content-md-center">
                        <div class="col-sm-12 col-lg-12 col-12">
                          <h2 class="text-center mb-3" style="font-weight: 500;color:#fff;">ฝากต่อเนื่อง</h2>
                          <img src="https://firebasestorage.googleapis.com/v0/b/phenixs789.firebasestorage.app/o/images%2F-Mz_mHdHPmA6AdSSde1r.png?alt=media&token=c2c6cbce-ba26-421b-b831-bbf2c96abdee" class="-cover-img img-fluid">
                        </div>
                      </div>
                    </fieldset>

                    <div class="text-title text-center" style="font-family: Kanit;">ฝากต่อเนื่อง</div>
                    <div class="row no-gutters">
                      <div class="col-6" >
                        <div class="card-report text-center" style="height:60px;display: flex; align-items: center; justify-content: center;">
                          <p class="mb-1" style="font-family: Kanit;">{{ (this.continues && this.continues.promotion)?this.continues.promotion.name:'ฝากต่อเนื่อง 7 วัน' }}</p>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card-report text-center" style="height:60px;">
                          <p class="mb-1" style="font-family: Kanit;">โบนัส</p>
                          <p class="mb-0">{{ numberWithCommas(this.continues.total )}}</p>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="card-report text-center">
                          <p class="mb-0">
                          <span class="dot" :style="(dots[0])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[1])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[2])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[3])?`background-color:#04af01`:''"></span>
                          <span class="dot dot2" :style="(dots[4])?`background-color:#04af01`:''"></span>
                          </p>
                          <p class="mb-0">
                          <span class="dot" :style="(dots[5])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[6])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[7])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[8])?`background-color:#04af01`:''"></span>
                          <span class="dot dot2" :style="(dots[9])?`background-color:#04af01`:''"></span>
                          </p>
                          <p class="mb-0">
                          <span class="dot" :style="(dots[10])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[11])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[12])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[13])?`background-color:#04af01`:''"></span>
                          <span class="dot dot2" :style="(dots[14])?`background-color:#04af01`:''"></span>
                          </p>
                          <p class="mb-0">
                          <span class="dot" :style="(dots[15])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[16])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[17])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[18])?`background-color:#04af01`:''"></span>
                          <span class="dot dot2" :style="(dots[19])?`background-color:#04af01`:''"></span>
                          </p>
                          <p class="mb-0">
                          <span class="dot" :style="(dots[20])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[21])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[22])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[23])?`background-color:#04af01`:''"></span>
                          <span class="dot dot2" :style="(dots[24])?`background-color:#04af01`:''"></span>
                          </p>
                          <p class="mb-0">
                          <span class="dot" :style="(dots[25])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[26])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[27])?`background-color:#04af01`:''"></span>
                          <span class="dot" :style="(dots[28])?`background-color:#04af01`:''"></span>
                          <span class="dot dot2" :style="(dots[29])?`background-color:#04af01`:''"></span>
                          </p>
                        </div>
                      </div>
                      <div class="col-12 text-center" style="padding-top:22px;">
                        <a href="javascript:void(0)" @click="moveContinuesToWallet()" class="text-white js-account-approve-aware btn" :style="checkStyle()" data-toggle="modal">
                          <div style="font-size: 14px;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">โอนเงินเข้ากระเป๋าหลัก</div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout mobile-only">
        <!-- Mobile Continue Cover Section -->
        <div class="x-cover x-index-event-container mobile-cover" style="padding-top: 63px;">
          <div class="container-fluid">
            <div class="row -contents-wrapper">
              <div class="col-12 col-md-6 -left-content"></div>
              <div class="col-12 col-md-6 -right-content bg-mobile">
                <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                  <div class="slick-list draggable" style="height: 58px;">
                    <div class="slick-track" style="opacity: 1; width: 4495px; top: 5px; display: flex; justify-content: flex-end; float: right;">
                      <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
                        <h1 class="-title">ฝากต่อเนื่อง <br> รับโบนัสทุกวัน</h1>
                        <p class="-sub-title">ฝากติดต่อกัน 7 วัน รับโบนัสพิเศษ</p>
                        <div class="-btn-wrapper d-none animated fadeInUp" data-animatable="fadeInUp" data-delay="500">
                          <a href="javascript:void(0)" class="btn -register-btn order-0" data-toggle="modal" data-target="#registerModal" tabindex="0">
                            <span class="-btn-title">สมัครสมาชิก</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Main Menu -->
        <MobileMainMenu :mainMenuItems="mainMenuItems" :user="user" />

        <!-- Mobile With Sidebar Layout -->
        <div class="mobile-with-sidebar">
          <!-- Mobile Left Sidebar -->
          <MobileLeftSidebar
            :leftMenuItems="leftMenuItems"
            :hoveredIndex="hoveredLeftIndex"
            :user="user"
            @menu-enter="onLeftMenuEnter"
            @menu-leave="onLeftMenuLeave"
          />

          <!-- Mobile Content Area -->
          <div class="mobile-content">
            <!-- Mobile Continue Content -->
            <div class="mobile-content-wrapper">
              <div class="x-continue-container">
                <div class="container">
                  <div class="row -continue-row-wrapper">
                    <div class="col-sm-12 col-lg-12 col-12 recommend_section">
                      <fieldset class="form-group text-center mb-0 px-1">
                        <div class="row mt-2 mb-0 mb-4 justify-content-md-center">
                          <div class="col-sm-12 col-lg-12 col-12">
                            <h2 class="text-center mb-3" style="font-weight: 500;color:#fff;">ฝากต่อเนื่อง</h2>
                            <img src="https://firebasestorage.googleapis.com/v0/b/phenixs789.firebasestorage.app/o/images%2F-Mz_mHdHPmA6AdSSde1r.png?alt=media&token=c2c6cbce-ba26-421b-b831-bbf2c96abdee" class="-cover-img img-fluid">
                          </div>
                        </div>
                      </fieldset>

                      <div class="text-title text-center" style="font-family: Kanit;">ฝากต่อเนื่อง</div>
                      <div class="row no-gutters">
                        <div class="col-6" >
                          <div class="card-report text-center" style="height:60px;display: flex; align-items: center; justify-content: center;">
                            <p class="mb-1" style="font-family: Kanit;">{{ (this.continues && this.continues.promotion)?this.continues.promotion.name:'ฝากต่อเนื่อง 7 วัน' }}</p>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card-report text-center" style="height:60px;">
                            <p class="mb-1" style="font-family: Kanit;">โบนัส</p>
                            <p class="mb-0">{{ numberWithCommas(this.continues.total )}}</p>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="card-report text-center">
                            <p class="mb-0">
                            <span class="dot" :style="(dots[0])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[1])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[2])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[3])?`background-color:#04af01`:''"></span>
                            <span class="dot dot2" :style="(dots[4])?`background-color:#04af01`:''"></span>
                            </p>
                            <p class="mb-0">
                            <span class="dot" :style="(dots[5])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[6])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[7])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[8])?`background-color:#04af01`:''"></span>
                            <span class="dot dot2" :style="(dots[9])?`background-color:#04af01`:''"></span>
                            </p>
                            <p class="mb-0">
                            <span class="dot" :style="(dots[10])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[11])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[12])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[13])?`background-color:#04af01`:''"></span>
                            <span class="dot dot2" :style="(dots[14])?`background-color:#04af01`:''"></span>
                            </p>
                            <p class="mb-0">
                            <span class="dot" :style="(dots[15])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[16])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[17])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[18])?`background-color:#04af01`:''"></span>
                            <span class="dot dot2" :style="(dots[19])?`background-color:#04af01`:''"></span>
                            </p>
                            <p class="mb-0">
                            <span class="dot" :style="(dots[20])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[21])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[22])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[23])?`background-color:#04af01`:''"></span>
                            <span class="dot dot2" :style="(dots[24])?`background-color:#04af01`:''"></span>
                            </p>
                            <p class="mb-0">
                            <span class="dot" :style="(dots[25])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[26])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[27])?`background-color:#04af01`:''"></span>
                            <span class="dot" :style="(dots[28])?`background-color:#04af01`:''"></span>
                            <span class="dot dot2" :style="(dots[29])?`background-color:#04af01`:''"></span>
                            </p>
                          </div>
                        </div>
                        <div class="col-12 text-center" style="padding-top:22px;">
                          <a href="javascript:void(0)" @click="moveContinuesToWallet()" class="text-white js-account-approve-aware btn" :style="checkStyle()" data-toggle="modal">
                            <div style="font-size: 14px;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">โอนเงินเข้ากระเป๋าหลัก</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<footerSection></footerSection>
</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'continues',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    LeftSidebar: () => import('@/components/LeftSidebar.vue'),
    MobileLeftSidebar: () => import('@/components/MobileLeftSidebar.vue'),
    MainMenuBar: () => import('@/components/MainMenuBar.vue'),
    MobileMainMenu: () => import('@/components/MobileMainMenu.vue'),
    RunningText: () => import('@/components/RunningText.vue')
  },
  data: function () {
    return {
      continues: [],
      dots: [],
      mainMenu: 'continue',
      hoveredLeftIndex: null,
      hoveredMainIndex: null,
      leftMenuItems: [
        { name: 'เล่นบ่อย', path: '/main?type=favorite', icon: require('@/assets/images/menu_left/left_1.png'), hoverIcon: require('@/assets/images/menu_left/left_1_hover.png') },
        { name: 'ยอดนิยม', path: '/main?type=popular', icon: require('@/assets/images/menu_left/left_2.png'), hoverIcon: require('@/assets/images/menu_left/left_2_hover.png') },
        { name: 'คาสิโน', path: '/main?type=casino', icon: require('@/assets/images/menu_left/left_3.png'), hoverIcon: require('@/assets/images/menu_left/left_3_hover.png') },
        { name: 'สล็อต', path: '/main?type=slot', icon: require('@/assets/images/menu_left/left_4.png'), hoverIcon: require('@/assets/images/menu_left/left_4_hover.png') },
        { name: 'ยิงปลา', path: '/main?type=fishing', icon: require('@/assets/images/menu_left/left_5.png'), hoverIcon: require('@/assets/images/menu_left/left_5_hover.png') },
        { name: 'กีฬา', path: '/playsport', icon: require('@/assets/images/menu_left/left_6.png'), hoverIcon: require('@/assets/images/menu_left/left_6_hover.png') },
        { name: 'esport', path: '/playesport', icon: require('@/assets/images/menu_left/left_7.png'), hoverIcon: require('@/assets/images/menu_left/left_7_hover.png') },
        { name: 'hilo', path: '/playlotto', icon: require('@/assets/images/menu_left/left_9.png'), hoverIcon: require('@/assets/images/menu_left/left_9_hover.png') }
      ],
      mainMenuItems: [
        { name: 'โปรโมชั่น', path: '/promotion', icon: require('@/assets/images/menu_main/main_menu_1.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_1.png') },
        { name: 'แลกของรางวัล', path: '/rewards', icon: require('@/assets/images/menu_main/main_menu_2.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_2.png') },
        { name: 'คืนยอดเล่น', path: '/cashback', icon: require('@/assets/images/menu_main/main_menu_3.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_3.png') },
        { name: 'สิทธิพิเศษ', path: '/event', icon: require('@/assets/images/menu_main/main_menu_4.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_4.png') },
        { name: 'พันธมิตร', path: '/partner', icon: require('@/assets/images/menu_main/main_menu_5.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_5.png') },
        // { name: 'ฝากต่อเนื่อง', path: '/continue', icon: require('@/assets/images/menu_main/main_menu_6.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_6.png') }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    // Menu hover methods
    onLeftMenuEnter (index) {
      this.hoveredLeftIndex = index
    },
    onLeftMenuLeave () {
      this.hoveredLeftIndex = null
    },
    onMainMenuEnter (index) {
      this.hoveredMainIndex = index
    },
    onMainMenuLeave () {
      this.hoveredMainIndex = null
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    moveContinuesToWallet () {
      if (this.continues.total && this.continues.key) {
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally((res) => {
          if (this.user.credit <= 5) {
            axios.get(`https://phenix.apifast.xyz/qcontinuous/continuous/${this.continues.key}`)
            setTimeout(() => {
              this.getContinues()
              this.$store.commit('user/SET_LOADING', false)
            }, 2000)
          } else {
            this.$swal({ icon: 'error', title: 'เงื่อนไข', text: 'ต้องมีเครดิตต่ำกว่า 5 บาท ถึงรับได้ค่ะ' })
            this.$store.commit('user/SET_LOADING', false)
          }
        }).catch(err => { console.error(err) })
      }
    },
    checkStyle () {
      if (this.continues && this.continues.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    },
    async getContinues () {
      const user = this.getUserId()
      if (user) {
        await firebase.firestore().collection('continuous_deposit').where('date', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) {
            this.continues = []
            this.dots = []
          }
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.continues = data
          })
        })
        // if (this.continues && this.continues.promotion) {
        //   for (let i = 0; i < Number(this.continues.promotion.numday); i++) {
        //     this.dots.push(true)
        //   }
        // } else {
          const fixed = 500
          let last = {}
          await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).orderBy('date', 'desc').limit(1).get().then((snapshot) => {
            snapshot.forEach((doc) => {
              const data = doc.data()
              data.key = doc.id
              last = data
            })
          })
          const dateCheck = []
          if (last && last.date) {
            await firebase.firestore().collection('daily_deposit').where('createdate', '>', last.date).where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(30).get().then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data().total >= fixed) {
                  dateCheck[doc.data().createdate] = true
                }
              })
            })
          } else {
            await firebase.firestore().collection('daily_deposit').where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(30).get().then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data().total >= fixed) {
                  dateCheck[doc.data().createdate] = true
                }
              })
            })
          }
          if (dateCheck) {
            for (let i = 1; i <= 7; i++) {
              if (dateCheck[moment().tz('Asia/Bangkok').add(-i, 'days').format('YYYY-MM-DD')]) {
                this.dots.push(true)
              } else {
                break
              }
            }
          // }
        }
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getContinues()
  }
}
</script>
<style scoped>
.dot {
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
.dot2 {
    margin-right: 0px;
}
@media (max-width: 500px) {
    .x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-img-category {
        width: 45px;
        height: 45px;
    }
}
@media (max-width: 991.98px) {
.x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-menu-text .-menu-text-main {
    font-size: .8rem;
    font-weight: bold;
    font-family: 'Kanit';
    text-align: center;
    display: block;
    padding-top: 4px;
}
}
@media (min-width: 991.98px) {
.x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-menu-text .-menu-text-main {
    font-size: 16px;
    font-weight: bold;
    font-family: 'Kanit';
    text-align: center;
    display: block;
    padding-top: 4px;
}
}
@media (min-width: 991.98px) {
.x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent {
    display: flex;
}
}
@media (max-width: 990px) {
#main_content_recommend .x-category-index, #main_content_income .x-category-index {
    padding-top: 10px;
}
}


/* Main Layout Styles */
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-image: url('../assets/images/Shiba-BG.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.desktop-layout {
  display: flex;
  flex: 1;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  padding: 20px 0;
}

.mobile-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.mobile-with-sidebar {
  display: flex;
  flex: 1;
}

.mobile-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.mobile-content-wrapper {
  flex: 1;
  padding: 20px 0;
}

/* Responsive classes */
@media (max-width: 991.98px) {
  .desktop-only {
    display: none !important;
  }
  .mobile-only {
    display: flex !important;
  }
}

@media (min-width: 992px) {
  .desktop-only {
    display: flex !important;
  }
  .mobile-only {
    display: none !important;
  }
}

/* Cover Section Styles */
.x-cover {
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  position: relative;
  overflow: hidden;
  height: 100px;
}

.mobile-cover {
  margin-top: 0;
}

.-contents-wrapper {
  min-height: 200px;
  align-items: center;
}

.-right-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  margin-bottom: 15px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.-sub-title {
  font-size: 1.2rem;
  color: rgba(255,255,255,0.9);
  margin-bottom: 20px;
}

@media (max-width: 767.98px) {
  .-title {
    font-size: 1.8rem;
  }
  .-sub-title {
    font-size: 1rem;
  }
}

</style>
